import { IPhongThiVm } from "../../../model/respone/tct/IPhongThiVm";
import { IPhongThiActionTypes } from "../../action-types/tct/IPhongThiActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IPhongThiReducer } from "../../reducer-model/tct/IPhongThiReducer";
const iniState: IPhongThiReducer = {
  dotThiIdSelected: 0
};
export const phongThiReducer = (state: IPhongThiReducer = iniState, action: IPhongThiActionTypes): IPhongThiReducer => {
  const dotThiId = action.payload?.dotThiId ?? 0;
  switch (action.type) {
    case "PHONG_THI_CHANGE_DOT_THI_ID":
      return {
        ...state,
        dotThiIdSelected: dotThiId

      };
    case "PHONG_THI_LOAD_START":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_loading,
        }
      };
    case "PHONG_THI_LOAD_SUCCESS":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_completed,
          phongThis: action.payload.data
        }
      };
    case "PHONG_THI_LOAD_ERROR":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_completed,
        }
      };
    case "PHONG_THI_SHOW_EDIT_MODAL":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          phongThiEditing: action.payload.data,
          isShowEditModal: true
        }
      };
    case "PHONG_THI_CLOSE_EDIT_MODAL":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          phongThiEditing: undefined,
          isShowEditModal: false
        }
      };
    case "PHONG_THI_SAVE_START":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_saving,
        }
      };
    case "PHONG_THI_SAVE_SUCCESS":
      let phongThisNew = [...(state[dotThiId].phongThis ?? [])]

      const idx = phongThisNew.findIndex(x => x.id_dot_thi_phong === action.payload.data.id_dot_thi_phong)
      if (idx < 0) {
        phongThisNew.push(action.payload.data as IPhongThiVm)
      } else {
        phongThisNew[idx] = action.payload.data as IPhongThiVm;
      }


      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          // status: eReducerStatusBase.is_completed,
          phongThis: phongThisNew,
          isShowEditModal: false,
          status: eReducerStatusBase.is_need_reload,
        }
      };
    case "PHONG_THI_SAVE_ERROR":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_completed,
        }
      };
    case "PHONG_THI_DELETE_START":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_deleting,
        }
      };
    case "PHONG_THI_DELETE_SUCCESS":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_need_reload,
          phongThis: (state[dotThiId].phongThis ?? []).filter(x => !action.payload.data.ids.includes(x.id_dot_thi_phong)),
          selectedIds: []
        }
      };
    case "PHONG_THI_DELETE_ERROR":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_completed,
        }
      };
    case "PHONG_THI_CHANGE_SELECTED_IDS":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          selectedIds: action.payload.data
        }
      };
    case "PHONG_THI_CHIA_THUC_CONG_START":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_saving,
        }
      };
    case "PHONG_THI_CHIA_THUC_CONG_SUCCESS":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_need_reload,
        }
      };
    case "PHONG_THI_CHIA_THUC_CONG_ERROR":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_completed,
        }
      };
    case "PHONG_THI_UPDATES_START":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_saving,
        }
      };
    case "PHONG_THI_UPDATES_SUCCESS":
      let phongThisNewUpdate = [...(state[dotThiId].phongThis ?? [])]
      action.payload.data.forEach(p => {
        const idx = phongThisNewUpdate.findIndex(x => x.id_dot_thi_phong === p.id_dot_thi_phong)
        if (idx < 0) {
          phongThisNewUpdate.push(p as IPhongThiVm)
        } else {
          phongThisNewUpdate[idx] = { ...phongThisNewUpdate[idx], ...p } as IPhongThiVm;
        }
      })
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_completed,
          phongThis: phongThisNewUpdate,
          isShowEditModal: false,

        }
      };
    case "PHONG_THI_UPDATES_ERROR":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_completed,
        }
      };
    case "PHONG_THI_CHANGE_FILTER":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          filter: action.payload.data
        }
      };
    case "PHONG_THI_CHANGE_FILTERS":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          filters: action.payload.data
        }
      };
    case "PHONG_THI_ID_DOT_THI_PHONG_CHANGED":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          id_dot_thi_phongs_changed: [...(state[dotThiId].id_dot_thi_phongs_changed ?? []), action.payload.data ?? 0]
        }
      };
    case "PHONG_THI_UPDATE_FIELD_CHANGED":
      const phongThisUpdated = [...(state[dotThiId].phongThis ?? [])];
    
      phongThisUpdated.forEach((phongThi, index) => {
        if (action.payload.data.id_dot_thi_phongs.includes(phongThi.id_dot_thi_phong)) {
          phongThisUpdated[index] = {
            ...phongThi,
            [action.payload.data.field]: action.payload.data.value,
            isChanged: true
          };
        }
      });    
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          phongThis: phongThisUpdated
        }
      };
    case "PHONG_THI_DU_KIEN_MO_PHONG_START":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_loading,
        }
      };
    case "PHONG_THI_DU_KIEN_MO_PHONG_SUCCESS":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          duKienMoPhong: action.payload.data,
          status: eReducerStatusBase.is_completed,
        }
      };
    case "PHONG_THI_DU_KIEN_MO_PHONG_ERROR":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_completed,
        }
      };
    case "PHONG_THI_UPDATE_DU_KIEN_MO_PHONG_START":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_loading,
        }
      };
    case "PHONG_THI_UPDATE_DU_KIEN_MO_PHONG_SUCCESS":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_need_reload,
        }
      };
    case "PHONG_THI_UPDATE_DU_KIEN_MO_PHONG_ERROR":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_completed,
        }
      };
    case "PHONG_THI_CHIA_PHONG_THEO_SO_LUONG_PHONG_START":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_saving,
        }
      };
    case "PHONG_THI_CHIA_PHONG_THEO_SO_LUONG_PHONG_SUCCESS":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_need_reload,
        }
      };
    case "PHONG_THI_CHIA_PHONG_THEO_SO_LUONG_PHONG_ERROR":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_completed,
        }
      };
    case "PHONG_THI_CHIA_SINH_VIEN_VAO_PHONG_START":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_saving,
        }
      };
    case "PHONG_THI_CHIA_SINH_VIEN_VAO_PHONG_SUCCESS":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_need_reload,
        }
      };
    case "PHONG_THI_CHIA_SINH_VIEN_VAO_PHONG_ERROR":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_completed,
        }
      };
    default:
      return state;
  }
};
